import { hotlineConsultantRequestContactText } from '@/feature/hotline/client/detail/contact/constant/text';
import { t } from '@/utils/constants/text/text';
import { z } from '@/utils/libs/zod/base';
const messages = t.validation;
const { label } = hotlineConsultantRequestContactText;
/**
 * 匿名コンサルホットライン 今後の進め方相談 schema
 */
export const hotlineClientContactFormSchema = z.object({
    /**
     * 希望条件
     */
    condition: z
        .string({ required_error: messages.required(label.condition()) })
        .min(1, messages.required(label.condition()))
        .max(10000, messages.maxLength(10000, label.condition())),
    /**
     * 相談内容
     */
    description: z
        .string({ required_error: messages.required(label.description()) })
        .min(1, messages.required(label.description()))
        .max(10000, messages.maxLength(10000, label.description())),
    /**
     * 相談希望日：第一希望
     */
    schedule1: z
        .string({ required_error: messages.required(label.schedule1()) })
        .min(1, messages.required(label.schedule1()))
        .max(255, messages.maxLength(255, label.schedule1())),
    /**
     * 相談希望日：第二希望
     */
    schedule2: z
        .string()
        .max(255, messages.maxLength(255, label.schedule2()))
        .or(z.literal(''))
        .optional(),
    /**
     * 相談希望日：第三希望
     */
    schedule3: z
        .string()
        .max(255, messages.maxLength(255, label.schedule3()))
        .or(z.literal(''))
        .optional(),
});
